import { RoomLookupErrorKind } from '@/src/lib/roomLookupError'

/**
 * Можно ли входить в звонок после загрузки страницы.
 *
 * Пока lookup не дал комнату, авто-вход с телефона и вход без формы должны
 * остаться на PreJoin под модалкой.
 */
export function canJoinAfterRoomLookup(
  roomLookupError: RoomLookupErrorKind | null | undefined,
): boolean {
  return !roomLookupError
}
